<!-- src/app/views/prueba-testimonial/dialog-form-prueba-testimonial/dialog-form-prueba-testimonial.component.html -->
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Prueba Testimonial</strong></h2>

<!-- Spinners para diferentes operaciones -->
<ngx-spinner [zIndex]="100" name="spCrearPruebaTestimonial" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spModificarPruebaTestimonial" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spEliminarPruebaTestimonial" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      <div class="delete-confirmation">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p>¿Está seguro que desea eliminar la prueba testimonial <strong>{{data.descripcion}}</strong>?</p>
        <p class="delete-warning">Esta acción no se puede deshacer.</p>
      </div>
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group class="form-tabs" animationDuration="300ms">

        <!-- Tab 1: Información Básica -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">info</mat-icon>
            Información Básica
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>title</mat-icon>
              </div>
              <mat-card-title>Información basica</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descripción</mat-label>
                    <input placeholder="Descripción de la prueba testimonial" type="text" formControlName="Descripcion"
                      matInput />
                    <mat-error *ngIf="f.Descripcion.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="f.Descripcion.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Grupo</mat-label>
                    <input placeholder="Número de grupo" type="number" formControlName="Grupo" matInput />
                    <mat-hint>Para agrupar testimoniales relacionados</mat-hint>
                    <mat-error *ngIf="f.Grupo.errors?.['min']">El grupo debe ser mayor a 0.</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observaciones</mat-label>
                    <textarea placeholder="Observaciones adicionales" formControlName="Observaciones" matInput
                      rows="4"></textarea>
                    <mat-error *ngIf="f.Observaciones.errors?.['maxlength']">Máximo 1000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 2: Personas Involucradas -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">people</mat-icon>
            Personas
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>person</mat-icon>
              </div>
              <mat-card-title> Persona Testigo</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12">
                  <app-buscar-persona [personaEntrada]="personaTestigoSeleccionada" [disable]="false" nombre="Testigo"
                    (eventEntity)="onPersonaTestigoSelected($event)">
                  </app-buscar-persona>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaUsuarios" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Usuario Responsable</mat-label>
                    <mat-select placeholder="Seleccione un usuario" formControlName="IdUsuarioResponsable">
                      <mat-option [value]="usuario.id"
                        *ngFor="let usuario of usuarios; let i = index; trackBy: trackByItems">
                        {{ usuario.nombre }} {{ usuario.apellido }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaTiposIntervinientes" bdColor="rgba(255,255,255,0.8)"
                      size="small" color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Tipo de Interviniente</mat-label>
                    <mat-select placeholder="Seleccione un tipo" formControlName="IdTipoInterviniente">
                      <mat-option [value]="tipo.id"
                        *ngFor="let tipo of tiposIntervinientes; let i = index; trackBy: trackByItems">
                        {{ tipo.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaEstados" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Estado de Prueba</mat-label>
                    <mat-select placeholder="Seleccione un estado" formControlName="IdEstadoPrueba">
                      <mat-option [value]="estado.id"
                        *ngFor="let estado of estadosPrueba; let i = index; trackBy: trackByItems">
                        {{ estado.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 3: Declaración -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">record_voice_over</mat-icon>
            Declaración
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>record_voice_over </mat-icon>
              </div>
              <mat-card-title> Declaración</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de Declaración</mat-label>
                    <input matInput [matDatepicker]="pickerDeclaracion" formControlName="FechaDeclaraion"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerDeclaracion"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDeclaracion></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Medio de Registro</mat-label>
                    <input matInput [formControl]="medioRegistroControl" [matAutocomplete]="autoMedio"
                      placeholder="Seleccione o escriba">
                    <mat-autocomplete #autoMedio="matAutocomplete">
                      <mat-option *ngFor="let medio of filteredMediosRegistro | async" [value]="medio">
                        {{ medio }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-hint>Seleccione de la lista o escriba uno personalizado</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Autoridad de Declaración</mat-label>
                    <input placeholder="Autoridad que recibe la declaración" type="text"
                      formControlName="AutoridadDeclaracion" matInput />
                    <mat-error *ngIf="f.AutoridadDeclaracion.errors?.['maxlength']">Máximo 200 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Declaración</mat-label>
                    <textarea placeholder="Contenido de la declaración testimonial" formControlName="Declaracion"
                      matInput rows="6"></textarea>
                    <mat-error *ngIf="f.Declaracion.errors?.['maxlength']">Máximo 2000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content></mat-card>
        </mat-tab>

        <!-- Tab 4: Audiencias -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">event</mat-icon>
            Audiencias
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>event</mat-icon>
              </div>
              <mat-card-title> Primera Audiencia</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Primera Audiencia</mat-label>
                    <input matInput [matDatepicker]="pickerPrimeraAud" formControlName="FechaPrimeraAudiencia"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerPrimeraAud"></mat-datepicker-toggle>
                    <mat-datepicker #pickerPrimeraAud></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Presentación</mat-label>
                    <input matInput [matDatepicker]="pickerCedPres1"
                      formControlName="FechaCedulaPresentacionPrimeraAudiencia" placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedPres1"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedPres1></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Notificación</mat-label>
                    <input matInput [matDatepicker]="pickerCedNot1"
                      formControlName="FechaCedulaNotificacionPrimeraAudiencia" placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedNot1"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedNot1></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>event_repeat</mat-icon>
              </div>
              <mat-card-title> Segunda Audiencia</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Segunda Audiencia</mat-label>
                    <input matInput [matDatepicker]="pickerSegundaAud" formControlName="FechaSegundaAudiencia"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerSegundaAud"></mat-datepicker-toggle>
                    <mat-datepicker #pickerSegundaAud></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Presentación</mat-label>
                    <input matInput [matDatepicker]="pickerCedPres2"
                      formControlName="FechaCedulaPresentacionSegundaAudiencia" placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedPres2"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedPres2></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Cédula Notificación</mat-label>
                    <input matInput [matDatepicker]="pickerCedNot2"
                      formControlName="FechaCedulaNotificacionSegundaAudiencia" placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerCedNot2"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCedNot2></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
  </form>

</mat-dialog-content>

<!-- Vista de solo lectura -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
  <div *ngIf="data" class="view-content">
    <mat-tab-group class="view-tabs">

      <!-- Tab 1: Información General -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          General
        </ng-template>

        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <div mat-card-avatar>
              <mat-icon>title</mat-icon>
            </div>
                    <mat-card-title>Información Básica</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Descripción:</span>
                      <span class="property-value">{{ data.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Observaciones:</span>
                      <span class="property-value">{{ data.observaciones | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Grupo:</span>
                      <span class="property-value">{{ data.grupo ? 'Grupo ' + data.grupo : 'Sin grupo' }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>

              <div class="col-sm-12 col-md-6">
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <div mat-card-avatar>
              <mat-icon>info</mat-icon>
            </div>
                    <mat-card-title>Estado y Expediente</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="property-row">
                      <span class="property-name">Estado de Prueba:</span>
                      <span class="property-value">{{ data.estadoPrueba?.descripcion | titlecase }}</span>
                    </div>
                    <div class="property-row">
                      <span class="property-name">Expediente:</span>
                      <span class="property-value">{{ data.expediente?.descripcion | titlecase }}</span>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <!-- Tab 2: Personas -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">people</mat-icon>
          Personas
        </ng-template>
<mat-card appearance="outlined" >
            <mat-card-header>
              <div mat-card-avatar>
              <mat-icon>persona</mat-icon>
            </div>
              <mat-card-title>Personas Involucradas</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="property-row">
                <span class="property-name">Persona Testigo:</span>
                <span class="property-value">{{ data.personaTestigo?.nombreCompleto | titlecase }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Usuario Responsable:</span>
                <span class="property-value">{{ data.usuarioResponsable?.nombreCompleto | titlecase }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Tipo Interviniente:</span>
                <span class="property-value">{{ data.tipoInterviniente?.descripcion | titlecase }}</span>
              </div>
            </mat-card-content>
          </mat-card>
      </mat-tab>

      <!-- Tab 3: Declaración -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">record_voice_over</mat-icon>
          Declaración
        </ng-template>

        <mat-card appearance="outlined" >
            <mat-card-header>
              <div mat-card-avatar>
              <mat-icon>record_voice_over></mat-icon>
            </div>
              <mat-card-title>Declaración</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="property-row">
                <span class="property-name">Fecha Declaración:</span>
                <span class="property-value">{{ data.fechaDeclaraion | date:'dd/MM/yyyy' }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Medio de Registro:</span>
                <span class="property-value">{{ data.medioRegistro | titlecase }}</span>
              </div>
              <div class="property-row">
                <span class="property-name">Autoridad Declaración:</span>
                <span class="property-value">{{ data.autoridadDeclaracion | titlecase }}</span>
              </div>
              <div class="property-row declaration-content">
                <span class="property-name">Declaración:</span>
                <div class="property-value declaration-text">{{ data.declaracion }}</div>
              </div>
            </mat-card-content>
          </mat-card>
      </mat-tab>

      <!-- Tab 4: Audiencias -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">event</mat-icon>
          Audiencias
        </ng-template>
        <mat-card appearance="outlined" >
            <mat-card-content>
               <div class="row">
            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" >
                <mat-card-header>
                  <div mat-card-avatar>
              <mat-icon>event</mat-icon>
            </div>
                  <mat-card-title>Primera Audiencia</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Fecha Primera Audiencia:</span>
                    <span class="property-value">{{ data.fechaPrimeraAudiencia | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Cédula Presentación:</span>
                    <span class="property-value">{{ data.fechaCedulaPresentacionPrimeraAudiencia | date:'dd/MM/yyyy'
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Cédula Notificación:</span>
                    <span class="property-value">{{ data.fechaCedulaNotificacionPrimeraAudiencia | date:'dd/MM/yyyy'
                      }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-sm-12 col-md-6">
              <mat-card appearance="outlined" >
                <mat-card-header>
                  <div mat-card-avatar>
              <mat-icon>event</mat-icon>
            </div>
                  <mat-card-title>Segunda Audiencia</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="property-row">
                    <span class="property-name">Fecha Segunda Audiencia:</span>
                    <span class="property-value">{{ data.fechaSegundaAudiencia | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Cédula Presentación:</span>
                    <span class="property-value">{{ data.fechaCedulaPresentacionSegundaAudiencia | date:'dd/MM/yyyy'
                      }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Fecha Cédula Notificación:</span>
                    <span class="property-value">{{ data.fechaCedulaNotificacionSegundaAudiencia | date:'dd/MM/yyyy'
                      }}</span>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <!-- Información de Auditoría -->
          <div class="row" *ngIf="data.fechaAlta || data.fechaModificacion">
            <div class="col-sm-12">
              <mat-card appearance="outlined" class="info-card audit-card">
                <mat-card-header>
                  <div mat-card-avatar>
              <mat-icon>visibility</mat-icon>
            </div>
                  <mat-card-title>Información de Auditoría</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="property-row">
                        <span class="property-name">Fecha de Alta:</span>
                        <span class="property-value">{{ data.fechaAlta | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                      <div class="property-row">
                        <span class="property-name">Creado por:</span>
                        <span class="property-value">{{ data.creadoPor?.descripcion || 'Sistema' }}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="property-row">
                        <span class="property-name">Última Modificación:</span>
                        <span class="property-value">{{ data.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                      <div class="property-row">
                        <span class="property-name">Modificado por:</span>
                        <span class="property-value">{{ data.modificadoPor?.descripcion }}</span>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
            </mat-card-content>
        </mat-card>

      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid" (click)="agregar()">
  </app-button-add>

  <app-button-save *ngIf="data.accion == accionesDialog.Modificar" [disabled]="!form.valid" [isDialogClose]="true"
    (saveClicked)="modificar()" (cancelClicked)="closeDialog()">
  </app-button-save>

  <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar" (click)="eliminar()" (cancelClicked)="closeDialog()"
    [isDialogClose]="true">
  </app-button-delete>
</mat-dialog-actions>
